import React from "react";
import TableCell from "@material-ui/core/TableCell";
import { Field } from "formik";
import { TextField } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import { useDispatch } from "react-redux";
import { setTheSectorPrice } from "../store/flights-list/flight-form.slice";
import { useTranslation } from "react-i18next";

const PricesCurrencyItem = ({ price, sectorId }: any) => {
    const dispatch = useDispatch();
    const { oneWayPrices, returnPrices } = price;
    const { t } = useTranslation();

    const updatePrice = (name: string, value: any) => {
        dispatch(
            setTheSectorPrice({
                sectorId,
                pricePayload: {
                    name,
                    value,
                },
            })
        );
    };

    const normalizeNumber = (rawValue: string) => {
        let value = parseFloat(rawValue);

        if (isNaN(value) || value < 0) {
            value = 0;
        }

        return Math.round(value * 100) / 100;
    };

    const handleChange = (e: any) => {
        const { name, value: rawValue } = e.target;

        // Important: allow user to delete 0 before writing another number
        if (rawValue === "") {
            updatePrice(name, "");
            return;
        }

        const value = normalizeNumber(rawValue);

        if (name === "oneWayForAdults" && value >= 20) {
            updatePrice(
                "returnForAdults",
                Math.max(0, Math.round((value - 10) * 100) / 100)
            );

            updatePrice(
                "oneWayForChildren",
                Math.max(0, Math.round((value - 10) * 100) / 100)
            );

            updatePrice(
                "returnForChildren",
                Math.max(0, Math.round((value - 20) * 100) / 100)
            );
        }

        updatePrice(name, value);

        updatePrice("oneWayForInfant", 50);
        updatePrice("returnForInfant", 40);
    };

    const handleChangeForInfants = (e: any) => {
        const { name, value: rawValue } = e.target;

        // Important: allow user to delete 0 before writing another number
        if (rawValue === "") {
            updatePrice(name, "");
            return;
        }

        const value = normalizeNumber(rawValue);

        updatePrice(name, value);
    };

    const handleBlur = (e: any) => {
        const { name, value } = e.target;

        // If user leaves the field empty, set it back to 0
        if (value === "") {
            updatePrice(name, 0);
        }
    };

    return (
        <TableRow>
            <TableCell style={{ borderBottom: "none" }}>
                <Field
                    type="number"
                    step="any"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="oneWayForAdults"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.ow",
                        "One Way"
                    )}
                    variant="outlined"
                    size="small"
                    value={oneWayPrices.forAdults ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />

                <Field
                    type="number"
                    step="any"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="returnForAdults"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.rt",
                        "Return"
                    )}
                    variant="outlined"
                    size="small"
                    value={returnPrices.forAdults ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />
            </TableCell>

            <TableCell style={{ borderBottom: "none" }}>
                <Field
                    type="number"
                    step="any"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="oneWayForChildren"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.ow",
                        "One Way"
                    )}
                    variant="outlined"
                    size="small"
                    value={oneWayPrices.forChildren ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />

                <Field
                    type="number"
                    step="any"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="returnForChildren"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.rt",
                        "Return"
                    )}
                    variant="outlined"
                    size="small"
                    value={returnPrices.forChildren ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />
            </TableCell>

            <TableCell style={{ borderBottom: "none" }}>
                <Field
                    type="number"
                    step="any"
                    onChange={handleChangeForInfants}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="oneWayForInfant"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.ow",
                        "One Way"
                    )}
                    variant="outlined"
                    size="small"
                    value={oneWayPrices.forInfants ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />

                <Field
                    type="number"
                    step="any"
                    onChange={handleChangeForInfants}
                    onBlur={handleBlur}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    name="returnForInfant"
                    label={t(
                        "app.main.flights.flightPriceTable.priceTable.rt",
                        "Return"
                    )}
                    variant="outlined"
                    size="small"
                    value={returnPrices.forInfants ?? ""}
                    style={{ margin: "8px" }}
                    as={TextField}
                    required
                />
            </TableCell>
        </TableRow>
    );
};

export default PricesCurrencyItem;
